/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5A.75.75 0 0 0 12 0C5.3726 0 0 5.3726 0 12s5.3726 12 12 12 12-5.3726 12-12a.75.75 0 0 0-1.5 0Zm1.2803-7.7197a.75.75 0 0 0-1.0606-1.0606L12.75 13.1893 8.0303 8.4697a.75.75 0 0 0-1.0606 1.0606l5.25 5.25.5303.5304.5303-.5304 10.5-10.5Z"
    clipRule="evenodd"
  />,
  'Check'
);
